import React from 'react';
import styled from 'styled-components';
import {fontWeight, fontFamily, fontSize} from '../../themes/fn';
import {font} from '@design/templateFns';

export interface DatesProps {
  startDate: string;
  endDate?: string;
  showTime?: boolean;
  showTimeZone?: boolean;
  dashSeparated?: boolean;
}

/*** STYLING ***/

const Wrapper = styled.div`
  ${font('eyebrow-lg')};
  ${fontWeight('bold')};
  display: inline;
`;

const DateSpan = styled.span`
  ${font('eyebrow-lg')};
`;

export const Dates = ({
  startDate,
  endDate,
  showTime,
  showTimeZone,
  dashSeparated,
}: DatesProps) => {
  const renderDateString = (dateIsoString: string): JSX.Element => {
    const dateObj = dateIsoString
      ? new Date(
          dateIsoString.match(/T.+/)
            ? dateIsoString
            : `${dateIsoString}T05:00:00.000Z`, // EST Eastern Standard Time
        ) // This regex ensures the correct date renders. Also won't break Safari.
      : new Date();
    const year = dateObj.getFullYear();
    const month = new Intl.DateTimeFormat('en-US', {month: 'long'}).format(
      dateObj,
    );
    const day = dateObj.getDate();
    const time = dateObj.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: 'numeric',
      hour12: true,
    });

    return (
      <DateSpan isBold={showTime}>
        {month} {day}
        <span>,</span> {year}{' '}
        {showTime && time && (
          <>
            <span>at</span> {time}
          </>
        )}
      </DateSpan>
    );
  };
  return (
    <Wrapper>
      {renderDateString(startDate)}
      {endDate && (
        <span>
          {' '}
          {dashSeparated ? '-' : 'to'} {renderDateString(endDate)}{' '}
        </span>
      )}
      {showTime && showTimeZone && 'Eastern'}
    </Wrapper>
  );
};
